var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"overflow":"auto","padding":"10px","white-space":"pre-wrap","font-size":"12px"},style:({ height: _vm.height })},[_vm._v(_vm._s(_vm.terms))])])
}
var staticRenderFns = []

export { render, staticRenderFns }